<template>
  <div
    @click.self="cancel()"
    class="modal fade show"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div
        v-if="removeModal"
        @click.self="removeModal = false"
        class="modal"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Удаление слота</h5>
            </div>
            <div class="modal-body">
              <p>Вы уверены что хотите удалить слот?</p>
            </div>
            <div class="modal-footer">
              <button
                @click="removeModal = false"
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Нет
              </button>
              <button @click="remove()" type="button" class="btn btn-primary">
                Да
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-content" style="height:400px">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Редактирования слота
          </h5>
         {{selectedSlot.day}}   {{ selectedSlot.start }} - {{ selectedSlot.end }}
        </div>
        <div class="modal-body">
          <form>
            <div class="select">
              <v-select
                placeholder="Выберите пациента..."
                v-model="patientControl"
                :options="patients"
                label="name"  @keyup.enter.native="openAddPatient($event.target.value)"
              >
                <template #selected-option="{ name, phone }">
                  <span class="name">{{ name }}</span>
                  <span class="more">({{ phone }})</span>
                </template>
                <template #option="{ name, phone }">
                  <div class="option-subtitle">{{ phone }}</div>
                  <div class="option-title">{{ name }}</div>
                </template>
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>. <div class="addPat" @click.prevent="openAddPatient(search)">
                          <span class="material-icons">add</span>Добавить </div>
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
              </v-select>
            </div>
            <div class="custom-control custom-switch">
              <input
                v-model="reserveControl"
                type="checkbox"
                class="custom-control-input"
                id="reserveSwitch"
                :disabled="patientControl"
              />
              <label class="custom-control-label" for="reserveSwitch">
                Зарезервировать
              </label>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <b-button variant="primary" @click="success()">
            Сохранить
          </b-button>
          <b-button variant="outline-primary" @click="cancel()">
            Отменить
          </b-button>
          <b-button variant="danger" @click="removeModal = true">
            Удалить
          </b-button>
        </div>
      </div>
    </div>
      <Dialog v-model="showCreatePatient" >
          <template #default>
                <div class="vm-header">
                  <span>Добавить пациента</span>
                </div>
                <div class="vm-content">
                  <form
                    class="vm-register-form form-material"
                    @submit.prevent="addPatient()"
                  >
                    <div class="form-group">
                          <label for="input-lastname">Фамилия:</label>
                          <input id="input-lastname"
                            v-model="registerForm.lastName"
                            type="text"
                            name="register-last-name"
                            class="form-control"
                            required
                          />
                    </div>
                    <div class="form-group">
                      <label for="input-firstname">Имя:</label>
                      <input id="input-firstname"
                        v-model="registerForm.firstName"
                        type="text"
                        name="register-first-name"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="input-middlename">Отчество:</label>
                      <input id="input-middlename"
                        v-model="registerForm.middleName"
                        type="text"
                        name="register-middle-name"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group">
                      <label for="input-phone">Телефон:</label>
                      <!--input id="input-phone"
                        v-model="registerForm.phone"
                        type="tel"
                        name="register-phone"
                        class="form-control"
                        required
                        maxlength="18"
                      /-->
                    <telephoneInput v-model="registerForm.phone" />

                    </div>
                    <div class="vm-bottom" style="display:flex; justify-content:space-between">
                      <b-button variant="primary" type="submit">
                        Добавить
                      </b-button>
                      <b-button variant="danger" @click="showCreatePatient=false">
                        Отменить
                      </b-button>
                    </div>
                  </form>
                </div>
              </template>
      </Dialog>
  </div>
</template>
<script>
import Dialog from '@app/components/uikit/Dialog';
import telephoneInput from '@app/components/uikit/telephoneInput';
import { patientApi } from '@app/services';

export default {
  components: {
    Dialog,
    telephoneInput
  },
  props: {
    patients: Array,
    selectedSlot: Object
  },
  data() {
    return {
      patientControl: this.selectedSlot.patient,
      reserveControl: this.selectedSlot.reserve,
      removeModal: false,
      skip: false,
      showCreatePatient: false,
      registerForm: {
        firstName: null,
        lastName: null,
        middleName: null,
        phone: null
      }
    };
  },
  created() {},
  mounted() {
    this.opened = true;
  },
  methods: {
    success() {
      const payload = {
        id: this.selectedSlot.id,
        patient: this.patientControl ? this.patientControl.id : null,
        reserve: this.reserveControl
      };
      this.$emit('success', payload);
    },
    cancel() {
      this.$emit('cancel');
    },
    remove() {
      this.$emit('remove', this.selectedSlot.id);
    },
    openAddPatient(str) {
      if (str.includes(' ')) {
        if (str.split(' ').length > 1 &&  str.split(' ').length < 3) {
          this.registerForm.lastName = str.split(' ')[0].charAt(0).toUpperCase() + str.split(' ')[0].slice(1);
          this.registerForm.firstName = str.split(' ')[1].charAt(0).toUpperCase() + str.split(' ')[1].slice(1);
        } else if (str.split(' ').length > 2 &&  str.split(' ').length < 4) {
          this.registerForm.lastName = str.split(' ')[0].charAt(0).toUpperCase() + str.split(' ')[0].slice(1);
          this.registerForm.firstName = str.split(' ')[1].charAt(0).toUpperCase() + str.split(' ')[1].slice(1);
          this.registerForm.middleName = str.split(' ')[2].charAt(0).toUpperCase() + str.split(' ')[2].slice(1);
        } else if (str.split(' ').length > 3 && str.split(' ').length < 5) {
          this.registerForm.lastName = str.split(' ')[0].charAt(0).toUpperCase() + str.split(' ')[0].slice(1);
          this.registerForm.firstName = str.split(' ')[1].charAt(0).toUpperCase() + str.split(' ')[1].slice(1);
          this.registerForm.middleName = str.split(' ')[2].charAt(0).toUpperCase() + str.split(' ')[2].slice(1);
          this.registerForm.phone = str.split(' ')[3];
        }
      } else {
        this.registerForm.lastName = str.charAt(0).toUpperCase() + str.slice(1);
      }

      this.showCreatePatient = true;
    },
    addPatient() {
      console.log(this.registerForm);
      const data = { 
                    first_name: this.registerForm.firstName,
                    last_name: this.registerForm.lastName,
                    middle_name: this.registerForm.middleName,
                    phone: this.registerForm.phone,
                    username: this.registerForm.phone
                    };
                patientApi.createPatient(data).then(res => {
                      toastr.info('Запись сохранена успешно');
                      const resdata = {
                        name: data.last_name + ' ' + data.first_name + ' ' + data.middle_name,
                        id: res.id,
                        phone: data.phone,
                      };
                      this.patients.push(resdata);
                      this.patientControl = resdata;
                   }).catch(error => { console.log(error);
                       toastr.error(error);
                   }).finally(fin => {
                      this.showCreatePatient = false;
                   });
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
}
.modal-footer {
  display: flex;
}
.modal-footer .btn-danger {
  margin-left: auto;
}
.select {
  margin-bottom: 12px;
}

::v-deep .vs__dropdown-menu {
  max-height: 150px;
}
.vm-header {
  color: #000;
  padding: 2rem;
  font-size: 2rem;
}
.vm-content {
  padding: 2rem;
}
.vm-submit-button {
  border: 0;
  border-radius: 3px;
  background-color: #4376c3;
  color: #fff;
  padding: 0.5rem 1rem;
  outline: none;
  transition: opacity 300ms ease;
  opacity: 1;
}
.vm-submit-button:disabled {
  opacity: 0.3;
}
.addPat {
  cursor: pointer;
}
.addPat:hover {
  color: #4376c3;
}
::v-deep .vm-dialog-content {
  z-index: 9999;
}

</style>
